import {
  List,
  ListItem,
  ListItemIconSkeleton,
  ListItemTextSkeleton,
} from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

export function CaseHistoryListSkeleton() {
  return (
    <Box sx={{ overflowY: "auto", width: "100%" }}>
      <List>
        <ListItem divider>
          <ListItemIconSkeleton />
          <ListItemTextSkeleton primaryWidth="60%" secondaryWidth="55%" />
        </ListItem>
        <ListItem divider sx={{ paddingBottom: 4 }}>
          <ListItemIconSkeleton />
          <ListItemTextSkeleton primaryWidth="60%" secondaryWidth="55%" />
        </ListItem>
        <ListItem divider>
          <ListItemIconSkeleton />
          <ListItemTextSkeleton primaryWidth="60%" secondaryWidth="55%" />
        </ListItem>
        <ListItem divider sx={{ paddingBottom: 4 }}>
          <ListItemIconSkeleton />
          <ListItemTextSkeleton primaryWidth="60%" secondaryWidth="55%" />
        </ListItem>
        <ListItem sx={{ paddingBottom: 4 }}>
          <ListItemIconSkeleton />
          <ListItemTextSkeleton primaryWidth="60%" secondaryWidth="55%" />
        </ListItem>
      </List>
    </Box>
  );
}
